import React from "react";

import { SvgIcon } from "@mui/material";

import { BinanceChip, BinanceTrChip, BitmexChip, DyDxChip, FtxChip, FtxTRChip, HuobiChip, OkxChip } from "images";

const fontSize = {
	fontSize: 46,
	width: "7rem",
	marginInlineStart: "-1.6rem",
};

const ExchangeType = ({ value }) => {
	if (value === "bitmex") {
		return (
			<SvgIcon style={fontSize}>
				<BitmexChip />
			</SvgIcon>
		);
	} else if (value === "binanceTr") {
		return (
			<SvgIcon style={fontSize}>
				<BinanceTrChip />
			</SvgIcon>
		);
	} else if (value === "huobi") {
		return (
			<SvgIcon style={fontSize}>
				<HuobiChip />
			</SvgIcon>
		);
	} else if (value === "dYdX") {
		return (
			<SvgIcon style={fontSize}>
				<DyDxChip />
			</SvgIcon>
		);
	} else if (value === "binance") {
		return (
			<SvgIcon style={fontSize}>
				<BinanceChip />
			</SvgIcon>
		);
	} else if (value === "ftx") {
		return (
			<SvgIcon style={fontSize}>
				<FtxChip />
			</SvgIcon>
		);
	} else if (value === "ftxTr") {
		return (
			<SvgIcon style={fontSize}>
				<FtxTRChip />
			</SvgIcon>
		);
	} else if (value === "okx") {
		return (
			<SvgIcon style={fontSize}>
				<OkxChip />
			</SvgIcon>
		);
	}
};

export default ExchangeType;
